export default function () {
  const body = document.querySelector('body');
  const tocElement = $('#toc');

  function checkToc() {
    if (!$('#toc li').length) {
      tocElement.remove();
    } else {
      tocElement.removeClass('hidden');
    }
  }

  if (body.classList.contains('page-template-help-article') && tocElement.length) {
    tocElement.toc({
      'selectors': 'h3,h4,h5,h6',
      'container': '.content-body',
      'prefix': 't',
      'smoothScrolling': false,
      'anchorName': function (i, heading, prefix) {
        // Firefox does not know innerText, so...
        var txt = heading.textContent || heading.innerText;

        // 1. replace spaces with underscores
        // 2. url encode all the things
        // 3. replace '%' from encoding with dots, otherwise Firefox doesn't get it...
        return encodeURIComponent(txt.replace(/ /g, '_')).replace(/%/g, '.');
      },
      'headerText': function (i, heading, $heading) {
        return $heading.text();
      },
      'itemClass': function (i, heading, $heading, prefix) {
        // Although we are using h3 to h6, it would still be nice to have .toc-1 to .toc-4 as classes
        var x = parseInt($heading[0].tagName.slice(1, 2), 10) - 2;

        return 'toc-' + x;
      }
    });
    checkToc();
  } else if ((body.classList.contains('page-template-blog-post')
    || body.classList.contains('page-template-blog-post-2019')
    || body.classList.contains('page-template-blog-post-blocks')
    || body.classList.contains('page-template-guide-post')
    || body.classList.contains('page-template-guide-post-2019')
    || body.classList.contains('page-template-guide-post-blocks')
    || body.classList.contains('page-template-page-webex-guide-article')) && tocElement.length) {
    tocElement.toc({
      'selectors': 'h6',
      'container': '.content-body',
      'prefix': 't',
      'smoothScrolling': false,
      'anchorName': function (i, heading, prefix) {
        // Firefox does not know innerText, so...
        var txt = heading.textContent || heading.innerText;

        // 1. replace spaces with underscores
        // 2. url encode all the things
        // 3. replace '%' from encoding with dots, otherwise Firefox doesn't get it...
        return encodeURIComponent(txt.replace(/ /g, '_')).replace(/%/g, '.');
      },
      'headerText': function (i, heading, $heading) {
        return $heading.text();
      },
      'itemClass': function (i, heading, $heading, prefix) {
        // Although we are using h3 to h6, it would still be nice to have .toc-1 to .toc-4 as classes
        var x = parseInt($heading[0].tagName.slice(1, 2), 10) - 2;

        return 'toc-' + x;
      }
    });
    checkToc();
  }

  /* Progress bar */
  if (body.classList.contains('page-template-blog-post-2019')
    || body.classList.contains('page-template-blog-post-blocks')
    || body.classList.contains('page-template-guide-post-2019')
    || body.classList.contains('page-template-guide-post-blocks')
    || body.classList.contains('page-template-page-webex-guide-article')) {
    let headerElement = document.querySelector('.header');
    let headerElementHeight = Math.ceil(headerElement.offsetHeight);
    let articleHeaderElement = document.querySelector('.article .article-header');
    let articleHeaderElementStyles = window.getComputedStyle(articleHeaderElement);
    let articleHeaderElementMargin = parseFloat(articleHeaderElementStyles.marginTop) + parseFloat(articleHeaderElementStyles.marginBottom);
    let articleHeaderElementHeight = Math.ceil(articleHeaderElement.offsetHeight + articleHeaderElementMargin);
    let contentElement = document.querySelector('.article .content-body');
    let contentElementStyles = window.getComputedStyle(contentElement);
    let contentElementMargin = parseFloat(contentElementStyles.marginTop) + parseFloat(contentElementStyles.marginBottom);
    let contentElementHeight = Math.ceil(contentElement.offsetHeight + contentElementMargin);
    let articleHeight = articleHeaderElementHeight + contentElementHeight;
    let progressBar = document.querySelector('#article-progressbar');
    let scrollTop = window.scrollY;
    let scrollPercent = ((scrollTop - headerElementHeight) / (articleHeight + headerElementHeight - window.innerHeight)) * 100;

    progressBar.setAttribute('value', scrollPercent);

    window.addEventListener('scroll', function () {
      scrollTop = window.scrollY;
      headerElementHeight = Math.ceil(headerElement.offsetHeight);
      articleHeaderElementHeight = Math.ceil(articleHeaderElement.offsetHeight + articleHeaderElementMargin);
      contentElementHeight = Math.ceil(contentElement.offsetHeight + contentElementMargin);
      articleHeight = articleHeaderElementHeight + contentElementHeight;
      scrollPercent = ((scrollTop - headerElementHeight) / (articleHeight + headerElementHeight - window.innerHeight)) * 100;
      progressBar.setAttribute('value', scrollPercent);
    });
  }

  // document.querySelectorAll('.post-popular-thanks').forEach(async el => {
  //   let res = await fetch(`${document.location.origin}/star-ratings${document.location.pathname}`);
  //   let data = await res.json();
  //   if (!data.votes) {
  //     return;
  //   }
  //   let ratingValue = Math.round((data.likes / data.votes) * 10) / 10;
  //   let content = `<span class="post-popular-likes">${data.votes}</span> Leser*innen bewerte${data.votes > 1 ? 'n' : ''} diesen Artikel mit durchschnittlich ${ratingValue} von 5 Sternen.`;
  //   document.querySelector('.post-popular-row')?._tippy.setContent(content)
  // })
}
